import { usePrismicDocument } from '@emico/prismic'

import { Category } from './graphql/schema.generated'

const usePrismicCategory = (categoryId: number) => {
    // The value of ID in `my.<ID>.<URL IDENTIFIER>` has to match with
    // a page type in prismic.
    // The value of URL IDENTIFIER has to match with a field, defined on the page type.
    const identifier = 'category_id'
    const pageTemplate = 'category'

    return usePrismicDocument<Category | undefined>(
        {
            key: `my.${pageTemplate}.${identifier}`,
            value: String(categoryId),
        },
        false,
        {
            // Use cache-and-network so cache is populated.
            // This will prevent content from popping in, and will prevent
            // loaders triggering when hook is triggered with the same categoryId
            fetchPolicy: 'cache-and-network',
        },
    )
}

export default usePrismicCategory
